import milonga from "../assets/audio/salwinski_milonga.mp3";
import air from "../assets/audio/bach_air.mp3";
import night from "../assets/audio/majkusiak_night.mp3";

export const musicData = [
  {
    id: 1,
    author: "Konrad Salwiński",
    title: "Milonga il pettine",
    music: milonga
  },
  {
    id: 2,
    author: "Johann Sebastian Bach",
    title: "Air on the G string",
    music: air
  },
  {
    id: 3,
    author: "Mikołaj Majkusiak",
    title: "One night of passion",
    music: night
  },
];
